import BaseApi, { Response } from './baseApi';
import {
  BaseClinicalSession,
  ClinicalSessionProgress,
  Step1Request,
  Step1Response,
  Step2Request,
  Step2Response,
  Step3Request,
  Step3Response,
  Step4Request,
  Step4Response,
  SaveSessionRequest,
  SaveSessionResponse,
} from '../dtos/FlowClinicalSessions/index';

class FlowClinicalApi extends BaseApi {
  private readonly basePath = '/flow-clinical';

  /**
   * Step 1: Initialize clinical session with GDPR consent and person identification
   * POST /api/flow-clinical/step1
   */
  async processStep1(data: Step1Request): Promise<Response<Step1Response>> {
    return this.post<Step1Response, Step1Request>(`${this.basePath}/step1`, data);
  }

  /**
   * Step 2: Process assessments and answers
   * POST /api/flow-clinical/step2
   */
  async processStep2(data: Step2Request): Promise<Response<Step2Response>> {
    return this.post<Step2Response, Step2Request>(`${this.basePath}/step2`, data);
  }

  /**
   * Step 3: Calculate risk levels and generate recommendations
   * POST /api/flow-clinical/step3
   */
  async processStep3(data: Step3Request): Promise<Response<Step3Response>> {
    return this.post<Step3Response, Step3Request>(`${this.basePath}/step3`, data);
  }

  /**
   * Step 4: Get guidance summary with risk calculations
   * POST /api/flow-clinical/step4
   */
  async processStep4(data: Step4Request): Promise<Response<Step4Response>> {
    return this.post<Step4Response, Step4Request>(`${this.basePath}/step4`, data);
  }

  /**
   * Get current session progress
   * GET /api/flow-clinical/{sessionId}/progress
   */
  async getProgress(sessionId: string): Promise<Response<ClinicalSessionProgress>> {
    return this.get<ClinicalSessionProgress>(`${this.basePath}/${sessionId}/progress`);
  }

  /**
   * Get full clinical session by ID
   * GET /api/flow-clinical/{sessionId}
   */
  async getSession(sessionId: string): Promise<Response<BaseClinicalSession | null>> {
    return this.get<BaseClinicalSession | null>(`${this.basePath}/${sessionId}`);
  }

  /**
   * Save current session progress. If no steps completed, saves as Draft.
   * If SessionId is empty or session doesn't exist, creates a new session.
   * POST /api/flow-clinical/save
   */
  async saveSession(data: SaveSessionRequest): Promise<Response<SaveSessionResponse>> {
    return this.post<SaveSessionResponse, SaveSessionRequest>(`${this.basePath}/save`, data);
  }
}

// Export singleton instance
export const flowClinicalApi = new FlowClinicalApi();

export default FlowClinicalApi;
